import { HolidayDateUtils } from '../HolidayDateUtils.ts';
import IconRobberCupid from '@static/images/icon_robber_cupid.svg';
import IconRobberSanta from '@static/images/icon_robber_santa.svg';
import IconRobber from '@static/images/icon_robber.svg';
class UIGameRobberSkinController {
    getRobberSkin() {
        return this.chosenSkin;
    }
    constructor(){
        const holiday = HolidayDateUtils.getCurrentHoliday();
        switch(holiday){
            case 'valentines':
                {
                    this.chosenSkin = IconRobberCupid;
                    break;
                }
            case 'christmas':
                {
                    this.chosenSkin = IconRobberSanta;
                    break;
                }
            default:
                this.chosenSkin = IconRobber;
                break;
        }
    }
}
export const robberSkinController = new UIGameRobberSkinController();
